import { render } from "./RankingSettings.vue?vue&type=template&id=ab8955e2"
import script from "./RankingSettings.vue?vue&type=script&lang=js"
export * from "./RankingSettings.vue?vue&type=script&lang=js"

import "./RankingSettings.vue?vue&type=style&index=0&id=ab8955e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__